<template>
  <div class="product_variants-extra" v-if="productVariants.length">
    <h3>Premium Packaging (Optional)</h3>
    <div class="product-variant__items">
      <div
        class="product-variant__item"
        :class="{
          'product-variant__item--active': activeProductVariantSelected(
            item.id
          ),
        }"
        v-for="(item, index) of productVariants"
        :key="index"
        @click="selecteProductVariant(index)"
      >
        <sib-image
          loading="lazy"
          v-bind="getImageProductVariant(item)"
        ></sib-image>

        <span class="product-variant__price">
          <input type="checkbox" :checked="index == indexChecked" />
          {{ formatPrice(item.price) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import { NullOrType, Product } from '@/types'
import { formatPrice } from '@/utils/product'
import { computed, onMounted, ref } from 'vue'

interface ProductVariantsExtraProps {
  productHandle: string
}
const props = withDefaults(defineProps<ProductVariantsExtraProps>(), {
  productHandle: '',
})
const productStore = useProductStore()
const product = ref<NullOrType<Product>>(null)
const productVariants = computed(() => product.value?.variants || [])
const indexChecked = ref(-1)

onMounted(() => {
  getProductExtraByHandle()
})

async function getProductExtraByHandle() {
  if (!props.productHandle) return
  product.value = await productStore.getProductByHandle({
    handle: props.productHandle,
    isForceLoadNewData: true,
  })
}

function selecteProductVariant(index: number) {
  if (!product.value?.variants?.length) return
  const variantSelected = product.value?.variants[index]
  const indexProductExtra = productStore.productsExtra.findIndex(
    (item) => product.value?.handle == item.productHanlde
  )
  if (indexProductExtra == -1) {
    productStore.productsExtra.push({
      productHanlde: product.value?.handle,
      productVariantIdSelected: variantSelected.id,
    })
  } else {
    productStore.productsExtra[indexProductExtra].productVariantIdSelected =
      variantSelected.id
  }
  if (indexChecked.value == index) {
    indexChecked.value = -1
    if (indexProductExtra != -1)
      productStore.productsExtra.splice(indexProductExtra, 1)
  } else {
    indexChecked.value = index
  }
}

function activeProductVariantSelected(variantId: string) {
  const isSelected = productStore.productsExtra?.find(
    (item) =>
      product.value?.handle == item.productHanlde &&
      item.productVariantIdSelected == variantId
  )
  return isSelected
}

function getImageProductVariant(productVariant: any) {
  return product.value?.images?.find(
    (item) => item.id == productVariant?.image?.id
  )
}
</script>

<style lang="scss">
.product_variants-extra {
  .product-variant {
    &__items {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 120px));
      gap: 0.75rem;
    }
    &__item {
      cursor: pointer;
      user-select: none;
      border: 3px solid var(--border-color);
      border-radius: 0.5rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      &--active {
        border: 3px solid var(--color-primary);
        box-shadow: rgba(222, 222, 222, 0.46) 0 0 3px 3px;
      }
      img {
        border-radius: 0.3rem 0.3rem 0 0;
      }
    }
    &__price {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      font-weight: 500;
      font-size: 12px;
      @include media-md-up {
        gap: 0.5rem;
        font-size: 1rem;
      }
      input {
        cursor: pointer;
      }
    }
  }
  h3 {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
</style>
